import produce, { Draft } from 'immer';
import { unionBy } from 'lodash';

// Models
import {
  PaginatedAlerts,
  RulesActionTypes,
  RulesState,
} from 'app/modules/rules/models';

// Constants
import {
  INITIAL_METADATA,
  INITIAL_FILTERS,
  initialCurrentRule,
} from 'app/modules/rules/constants';

// Actions
import { RulesActions } from 'app/modules/rules/actions';

// Utils
import deepFreeze from 'app/shared/utils/deepFreeze';

const initialState: RulesState = {
  componentRules: {
    rules: [],
    count: 0,
  },
  editingRule: {
    metadata: INITIAL_METADATA,
    tags: [],
    filters: INITIAL_FILTERS,
    scenarioName: null,
    parameters: {},
    isValidated: false,
    duplicateRule: false,
    execution_frequency: '30min',
    embeddedFilters: {},
    queue: undefined,
    runs_on_org_id: undefined,
    visible_to_child_org: false,
  },

  currentRule: {
    rule: { ...initialCurrentRule },
    paginated_alerts: {
      alerts: [],
      count: 0,
    } as PaginatedAlerts,
  },
};
// to ensure initialState is readonly
deepFreeze(initialState);

const immerRulesReducer = (state = initialState, action: RulesActions) =>
  produce(state, (draft: Draft<RulesState>) => {
    switch (action.type) {
      case RulesActionTypes.RETRIEVE_TRIGGERED_ALERTS_SUCCESS:
        draft.currentRule.paginated_alerts = action.payload;
        return;

      case RulesActionTypes.RETRIEVE_COMPONENT_RULES_SUCCESS:
        draft.componentRules.rules = unionBy(
          draft.componentRules.rules,
          action.payload.rules,
          'id',
        );
        draft.componentRules.count = action.payload.count;
        return;

      case RulesActionTypes.SET_EDITING_RULE:
        draft.editingRule = {
          ...action.payload,
          isValidated:
            typeof action.payload.isValidated === 'undefined'
              ? false
              : action.payload.isValidated,
          duplicateRule: false,
        };
        return;

      case RulesActionTypes.SET_DYNAMIC_COLUMN_DEFINITION_ID:
        draft.editingRule.parameters.dynamic_column_definition_id =
          action.payload;
        return;

      case RulesActionTypes.SET_ADDITIONAL_FIELDS_IN_RULE_PARAMETERS:
        draft.editingRule.parameters.additional_fields = action.payload;
    }
  });

export { immerRulesReducer, initialState };
